/*
Author: Chathuraka Mallawa Arachchi
Date: 15/05/2025
Copyright © 2024 Infix!. All rights reserved.
*/

import { RootState } from '@/reducers/store'
import { useUpdateAnswersStatus } from '@/state/survey/saveAnswerSlice'
import { useSelector } from 'react-redux'
import { INode } from '../../SurveyModel/types/nodeTypes'

interface IComplete {
    node: INode
}

const Complete: React.FC<IComplete> = () => {
    //repeatedElement - only available with complex question types with repeated nodes.
    const updateAnswersStatusDispatch = useUpdateAnswersStatus()
    const { patient } = useSelector((state: RootState) => state.patientSurvey)
    const handleCompleteAndSubmit = () => {
        updateAnswersStatusDispatch(
            patient.waitingListRecordId,
            patient.questionnaireResponseId
        )
    }

    return (
        <div>
            <div className="flex justify-center">
                <div
                    onClick={() => {
                        handleCompleteAndSubmit()
                    }}
                    className="px-6 py-2 bg-primary text-white text-sm  rounded-md cursor-pointer hover:bg-primary-dark w-max"
                >
                    Complete and submit
                </div>
            </div>
        </div>
    )
}

export default Complete
